var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Transition",
    { staticClass: "component-loading full-center", attrs: { appear: "" } },
    [
      _c("BaseIcon", {
        class: _vm.$style.loadingIcon,
        attrs: { name: "sync", spin: "" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }